import type { BlokProps } from "@trydig/storyblok";
import NextLink from "next/link";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Button } from "@/components/ui/Button";
import { PageHeader } from "@/components/ui/sections/PageHeader";
import type { PageHeaderStoryblok } from "@/generated/sb/sb-types";
import { sbLink } from "@/lib/storyblok/link";

export const PageHeaderBlok = ({ blok, preview }: BlokProps<PageHeaderStoryblok>) => {
	const size = blok.size ?? "level-1";

	const actionHref = sbLink(blok.actionLink)?.href;
	const action =
		size === "level-3" && blok.actionLabel && actionHref ? (
			<Button as={NextLink} href={actionHref} variant="outline" color="primary" size="large">
				{blok.actionLabel}
			</Button>
		) : undefined;

	return (
		<BlokWrap editable={blok}>
			<PageHeader
				size={size}
				title={blok.title || undefined}
				description={blok.description || undefined}
				subcategories={blok.subcategories}
				collections={blok.collections}
				action={action}
				preview={preview}
			/>
		</BlokWrap>
	);
};
